import { isEqual } from "lodash";
import { useContext, useLayoutEffect, useState } from "react";
import { Subject } from "rxjs/internal/Subject";
import { Subscription } from "rxjs/internal/Subscription";
import { distinctUntilChanged, map, tap } from "rxjs/operators";
import { FormContext } from "./FormContext";
import {
  IFormContextValue,
  IFormState,
  IFormValues,
  TChildrenRender
} from "./formInterfaces";

interface IFormValuesInnerProps {
  formValues: IFormValues;
  updateFormValues: IFormContextValue["updateFormValues"];
}

interface IFormValuesProps {
  children: TChildrenRender<IFormValuesInnerProps>;
}

export function FormValues(props: IFormValuesProps) {
  const { updateFormValues, subscribe } = useContext(FormContext);

  const [formValues, setFormValues] = useState();
  useLayoutEffect(() => {
    let subscription: Subscription | null = null;

    const formStateObserver$ = new Subject<IFormState>();
    formStateObserver$
      .pipe(
        map((formState: IFormState) => ({
          ...formState.values
        })),
        distinctUntilChanged(isEqual),
        tap((values: IFormValues) => setFormValues(values))
      )
      .subscribe();

    subscription = subscribe(formStateObserver$);

    return () => {
      if (subscription) {
        subscription.unsubscribe();
        subscription = null;
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // if field is not regiester yet, return null
  if (!formValues) return null;

  return props.children({
    formValues,
    updateFormValues
  });
}
